// Shared request-type config for the whiteboard, kiosk, dispatch board and rep form
export const REQUEST_TYPE_LABELS = {
  delivery: "Delivery",
  collection: "Collection",
  click_collect: "Click & Collect",
};

export const PICKUP_POINTS = ["Wide Format", "Despatch Rack", "Courier Pick Up", "Pallet at back Gate"];

export const isClickCollect = (job) => (job?.request_type || "").toLowerCase() === "click_collect";

export const requestTypeLabel = (type) => REQUEST_TYPE_LABELS[(type || "delivery").toLowerCase()] || "Delivery";

export const doneLabel = (job) => (isClickCollect(job) ? "COLLECTED" : "DELIVERED");

// "2026-06-15" -> "Mon 15 Jun" (parsed as a local date, not UTC)
export const formatWaitingSince = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-IE", { weekday: "short", day: "numeric", month: "short" });
};

// Whole days a rolled-over item has been waiting (from its original scheduled day)
export const daysWaiting = (iso) => {
  if (!iso) return 0;
  const [y, m, d] = iso.split("-").map(Number);
  const start = new Date(y, m - 1, d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((today - start) / 86400000));
};

export const CC_ALERT_DAYS = 2;

export const isOverdueClickCollect = (job) =>
  isClickCollect(job) && !job.delivered && daysWaiting(job.carried_from) > CC_ALERT_DAYS;
